import { useEffect, useState } from "react";
import Titulo from "../../../atoms/titles/Titulo";
import { handleData } from "../../../../utils/HandleUtils";
import DataTablePaginacionExterna from "../../../atoms/datatable/DataTablePaginacionExterna";
import ConstantesTabla from "../../../../utils/ConstantesTabla";

import { SpinnerCircle } from "../../../atoms/spinner/Spinner";
import { Iconos } from "../../../../utils/Iconos";
import { darAltaUsuarioWeb, getBusquedaUsuariosBaja } from "../../../services/UsuariosWebService";
import ModalShowUsuarioAlta from "../../../molecules/modals/modalsUsuariosWeb/ModalShowUsuarioAlta";
import Confirm from "../../../molecules/modals/Confirm";
import "./../usuariosweb.scss"

const NuevaAltaUsuario = (object) => {
    const [loading, setLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [data, setData] = useState();
    const [totalPages, setTotalPages] = useState(0);
    const [usuarioAlta, setUsuarioAlta] = useState({})
    const [showUser, setShowUser] = useState(false);
    const [setBusquedaRealizada] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false);
    const [niepUsuarioSeleccionado, setNiepUsuarioSeleccionado] = useState();

    const handleShowConfirm = (dni) => {
        setShowConfirm(!showConfirm);
        setNiepUsuarioSeleccionado(dni)
    };

    const handleCloseConfirm = (e) => {
        setShowConfirm(false);
    };

    const handleShowUsuario = () => {
        setShowUser(!showUser);
    };

    const handleCloseUsuario = (e) => {
        setShowUser(false);
    };

    const [formBus, setFormBus] = useState({
        dni: null,
        nombre: null,
        apellido1: null,
        apellido2: null
    })

    const acciones = {
        name: "Dar de alta",
        selector: (row) => (<><div className="cursorPointer" onClick={() => handleShowConfirm(row[4])}>
            {Iconos.iconoPen}
        </div>
        </>)
        ,
        wrap: true,
        grow: .6, // Set grow to 0 to prevent the column from taking up extra space
        maxWidth: "200px", // Set a fixed width for the column

        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }
    }

    const handleEnvioBusqueda = (valores, currentPage, pageSize) => {
        
        
        
        setLoading(true)
        // setBusquedaRealizada(false)
        getBusquedaUsuariosBaja(valores, currentPage, pageSize).then((data) => {
            
            setData(data)
            setTotalPages(data.totalPages);
            // setBusquedaRealizada(true)
            setLoading(false)
        })
    }

    const handleDarAltaUsuario = (niep) => {
        setShowConfirm(false)
        darAltaUsuarioWeb(niep).then((data) => {
            setUsuarioAlta(data)
            setLoading(true)
            handleShowUsuario()
            setBusquedaRealizada(false)
            getBusquedaUsuariosBaja(formBus, currentPage, pageSize).then((data) => {
                
                setData(data)
                setTotalPages(data.totalPages);
                setLoading(false)
                setBusquedaRealizada(true)
            })
        })
    }

    useEffect(()=>{
        
        if (currentPage>=0 && pageSize>=0) {
            getBusquedaUsuariosBaja(formBus, currentPage, pageSize).then((data) => {
                
                setData(data)
                setTotalPages(data.totalPages);
                // setBusquedaRealizada(true)
                setLoading(false)
            })
        }
        
    },[currentPage,pageSize,formBus])


    return (<>
        <div className="container-fluid">
            <div className="formNuevaAltaUsuario">
                <div className="mt-2 text-center row tituloAltaUsuarioWeb">
                    <Titulo
                        titulo="Introduzca los parámetros que determinarán el usuario al que quiera dar de alta"
                        tipo="tituloPagina3"
                        clases={""}
                    />
                </div>
                <div className="formBusqueda mt-3 mb-5">
                    <div className="row d-flex justify-content-center mb-2">
                        <div className="col-6 row align-items-center">
                            <label htmlFor="dniAcceso" className="col-4">DNI:</label>
                            <div className="col-8">
                                <input type="text"  id="dniAcceso" className="form-control"
                                    onChange={(e) => handleData(e.target.value, "dni", setFormBus)}
                                />
                            </div>
                        </div>
                        <div className="col-6 row align-items-center">
                            <label htmlFor="nombreAcceso" className="col-4">Nombre:</label>
                            <div className="col-8">
                                <input type="text" id="nombreAcceso" className="form-control"

                                    onChange={(e) => handleData(e.target.value, "nombre", setFormBus)}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="row d-flex justify-content-center">
                        <div className="col-6 row align-items-center">
                            <label htmlFor="ape1Acceso" className="col-4">Apellido 1:</label>
                            <div className="col-8">
                                <input type="text" id="ape1Acceso" className="form-control"
                                    onChange={(e) => handleData(e.target.value, "apellido1", setFormBus)}
                                />
                            </div>
                        </div>
                        <div className="col-6 row align-items-center">
                            <label htmlFor="ape2Acceso" className="col-4">Apellido 2:</label>
                            <div className="col-8">
                                <input type="text" id="ape2Acceso" className="form-control"
                                    onChange={(e) => handleData(e.target.value, "apellido2", setFormBus)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-5 justify-content-between">
                        <div className="col-3 ">
                            <button
                                className={`btnRed rounded p-1`}
                                type="button"
                                onClick={() => object.setZona({ links: true })}
                            >
                                <i className="fa-solid fa-rotate-left"></i>{" "}
                                Volver
                            </button>
                        </div>
                        <div className="col-3 ">
                            <button
                                className={`btn rounded p-1`}
                                type="button"
                                onClick={() => handleEnvioBusqueda(formBus, currentPage, pageSize)}
                            >
                                Buscar
                            </button>
                        </div>
                    </div>
                </div>
                <div className="tablaUsuariosBaja">
                    {loading && data !== undefined && data !== null ? (<><div><SpinnerCircle /></div></>) : (<>
                    {data !== undefined ? (<>
                        {data?.content?.length !== 0 ? (<>
                            <DataTablePaginacionExterna
                                data={data}
                                columnas={[
                                    ...ConstantesTabla.columnasAltaUsuariosWeb, acciones
                                ]}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                totalPages={totalPages}
                            />
                        </>) : (<>  <div className="row">
                            <span className="text-center col">No hay usuarios que respondan a esos parámetros de búsqueda</span>
                            </div></>)}
                    </>):null}
                       

                    </>)}

                </div>
            </div>
        </div>

        {showUser ? (<>
            <ModalShowUsuarioAlta
                show={showUser}
                handleClose={handleCloseUsuario}
                titulo="Error al recuperar el PDF"
                tipo="tituloBorrador rojo"
                usuario={usuarioAlta}
            />
        </>) : null}

        {showConfirm ? (
              <>
                <Confirm
                  show={showConfirm}
                  handleClose={handleCloseConfirm}
                  titulo="Confirmación"
                  mensaje="¿Estás seguro que quieres dar de alta a este usuario?"
                  funcion={() => handleDarAltaUsuario(niepUsuarioSeleccionado)}
               />
              </>
            ) : null}
    </>)
}

export default NuevaAltaUsuario;
